import { Divider, Skeleton, Stack } from "@mui/material";
import Block from "@/components/Block";

export default function TabletSummaryCardSkeleton() {
  return (
    <Block sx={{ position: "relative" }}>
      <Divider
        orientation="vertical"
        sx={{ position: "absolute", top: 0, bottom: 0, left: "50%", transform: "translateX(-50%)" }}
      />
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flex: 1, minWidth: 0 }} justifyContent="center" spacing={1}>
          <Skeleton variant="text" width="60%" height={30} />
          <Skeleton variant="text" width="80%" height={18} />
        </Stack>
        <Stack sx={{ flex: 1, minWidth: 0 }} justifyContent="center" spacing={1}>
          <Skeleton variant="text" width="90%" height={20} />
        </Stack>
      </Stack>
    </Block>
  );
}
